!(function (e, t) {
  'object' == typeof exports && 'undefined' != typeof module
    ? (module.exports = t())
    : 'function' == typeof define && define.amd
      ? define(t)
      : ((e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}), (e.ReactIntlLocaleData.be = t()));
})(this, function () {
  'use strict';
  return [
    {
      locale: 'be',
      pluralRuleFunction: function (e, t) {
        var a = String(e).split('.'),
          r = Number(a[0]) == e,
          o = r && a[0].slice(-1),
          n = r && a[0].slice(-2);
        return t
          ? (2 != o && 3 != o) || 12 == n || 13 == n
            ? 'other'
            : 'few'
          : 1 == o && 11 != n
            ? 'one'
            : o >= 2 && o <= 4 && (n < 12 || n > 14)
              ? 'few'
              : (r && 0 == o) || (o >= 5 && o <= 9) || (n >= 11 && n <= 14)
                ? 'many'
                : 'other';
      },
      fields: {
        year: {
          displayName: 'год',
          relative: { 0: 'у гэтым годзе', 1: 'у наступным годзе', '-1': 'у мінулым годзе' },
          relativeTime: {
            future: { one: 'праз {0} год', few: 'праз {0} гады', many: 'праз {0} гадоў', other: 'праз {0} года' },
            past: { one: '{0} год таму', few: '{0} гады таму', many: '{0} гадоў таму', other: '{0} года таму' }
          }
        },
        'year-short': {
          displayName: 'г.',
          relative: { 0: 'у гэтым годзе', 1: 'у наступным годзе', '-1': 'у мінулым годзе' },
          relativeTime: {
            future: { one: 'праз {0} г.', few: 'праз {0} г.', many: 'праз {0} г.', other: 'праз {0} г.' },
            past: { one: '{0} г. таму', few: '{0} г. таму', many: '{0} г. таму', other: '{0} г. таму' }
          }
        },
        month: {
          displayName: 'месяц',
          relative: { 0: 'у гэтым месяцы', 1: 'у наступным месяцы', '-1': 'у мінулым месяцы' },
          relativeTime: {
            future: {
              one: 'праз {0} месяц',
              few: 'праз {0} месяцы',
              many: 'праз {0} месяцаў',
              other: 'праз {0} месяца'
            },
            past: { one: '{0} месяц таму', few: '{0} месяцы таму', many: '{0} месяцаў таму', other: '{0} месяца таму' }
          }
        },
        'month-short': {
          displayName: 'мес.',
          relative: { 0: 'у гэтым месяцы', 1: 'у наступным месяцы', '-1': 'у мінулым месяцы' },
          relativeTime: {
            future: { one: 'праз {0} мес.', few: 'праз {0} мес.', many: 'праз {0} мес.', other: 'праз {0} мес.' },
            past: { one: '{0} мес. таму', few: '{0} мес. таму', many: '{0} мес. таму', other: '{0} мес. таму' }
          }
        },
        day: {
          displayName: 'дзень',
          relative: { 0: 'сёння', 1: 'заўтра', 2: 'паслязаўтра', '-2': 'пазаўчора', '-1': 'учора' },
          relativeTime: {
            future: { one: 'праз {0} дзень', few: 'праз {0} дні', many: 'праз {0} дзён', other: 'праз {0} дня' },
            past: { one: '{0} дзень таму', few: '{0} дні таму', many: '{0} дзён таму', other: '{0} дня таму' }
          }
        },
        'day-short': {
          displayName: 'дзень',
          relative: { 0: 'сёння', 1: 'заўтра', 2: 'паслязаўтра', '-2': 'пазаўчора', '-1': 'учора' },
          relativeTime: {
            future: { one: 'праз {0} дзень', few: 'праз {0} дні', many: 'праз {0} дзён', other: 'праз {0} дня' },
            past: { one: '{0} дзень таму', few: '{0} дні таму', many: '{0} дзён таму', other: '{0} дня таму' }
          }
        },
        hour: {
          displayName: 'гадзіна',
          relative: { 0: 'у гэту гадзіну' },
          relativeTime: {
            future: {
              one: 'праз {0} гадзіну',
              few: 'праз {0} гадзіны',
              many: 'праз {0} гадзін',
              other: 'праз {0} гадзіны'
            },
            past: {
              one: '{0} гадзіну таму',
              few: '{0} гадзіны таму',
              many: '{0} гадзін таму',
              other: '{0} гадзіны таму'
            }
          }
        },
        'hour-short': {
          displayName: 'гадз',
          relative: { 0: 'у гэту гадзіну' },
          relativeTime: {
            future: { one: 'праз {0} гадз', few: 'праз {0} гадз', many: 'праз {0} гадз', other: 'праз {0} гадз' },
            past: { one: '{0} гадз таму', few: '{0} гадз таму', many: '{0} гадз таму', other: '{0} гадз таму' }
          }
        },
        minute: {
          displayName: 'хвіліна',
          relative: { 0: 'у гэту хвіліну' },
          relativeTime: {
            future: {
              one: 'праз {0} хвіліну',
              few: 'праз {0} хвіліны',
              many: 'праз {0} хвілін',
              other: 'праз {0} хвіліны'
            },
            past: {
              one: '{0} хвіліну таму',
              few: '{0} хвіліны таму',
              many: '{0} хвілін таму',
              other: '{0} хвіліны таму'
            }
          }
        },
        'minute-short': {
          displayName: 'хв',
          relative: { 0: 'у гэту хвіліну' },
          relativeTime: {
            future: { one: 'праз {0} хв', few: 'праз {0} хв', many: 'праз {0} хв', other: 'праз {0} хв' },
            past: { one: '{0} хв таму', few: '{0} хв таму', many: '{0} хв таму', other: '{0} хв таму' }
          }
        },
        second: {
          displayName: 'секунда',
          relative: { 0: 'цяпер' },
          relativeTime: {
            future: {
              one: 'праз {0} секунду',
              few: 'праз {0} секунды',
              many: 'праз {0} секунд',
              other: 'праз {0} секунды'
            },
            past: {
              one: '{0} секунду таму',
              few: '{0} секунды таму',
              many: '{0} секунд таму',
              other: '{0} секунды таму'
            }
          }
        },
        'second-short': {
          displayName: 'с',
          relative: { 0: 'цяпер' },
          relativeTime: {
            future: { one: 'праз {0} с', few: 'праз {0} с', many: 'праз {0} с', other: 'праз {0} с' },
            past: { one: '{0} с таму', few: '{0} с таму', many: '{0} с таму', other: '{0} с таму' }
          }
        }
      }
    }
  ];
});
